import { Data } from '@telstra-connect/utils';
import { State as LoginState } from '@telstra-connect/login';

enum UserRole {
    TCONRelationshipType = 'acr',
    adminUserAuthority = 'Full Authority',
}

export function getProfileFromAuthToken(userState: LoginState.IUserState) {
    try {
        // Token issuer is checked againest OKAPI SSO issuer URI
        return userState.oauth.authIssuer === `https://api.in.telstra.com.au/sso` ? Data.UserType.staffUser : Data.UserType.customerUser;
    } catch (error) {
        return Data.UserType.customerUser;
    }
}

export const checkIfStaffUser = (state) => {
    try {
        return state.tokens.customerProfile?.data?.profile === 'staff_user'
    } catch (error) {
        return undefined
    }
}

export const isAdminUser = (userProfile: LoginState.IUserProfile) =>
    (userProfile.roles.some((role) => role.relationshipType === UserRole.TCONRelationshipType
        && role.name === UserRole.adminUserAuthority && role.value === userProfile.defaultCompanyId));
